import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppBarActionsComponent, AppBarCloseAction, AppBarComponent, AppBarTitleComponent, AppPageComponent, AppSidenavComponent } from 'common';
import { AppBarDropdownComponent } from '../../shared/app-bar-dropdown/app-bar-dropdown.component';
import { AppPageResolver, AppSidenavItemsResolver } from '../../app.resolver';
import { appBarData, appBarDropdownData } from '../../app.data';
import { BrokerApiKeyListComponent } from './features/broker-api-key-list/broker-api-key-list.component';
import { BrokerApiKeyDetailsComponent } from './features/broker-api-key-details/broker-api-key-details.component';
import { AdminApiGuard } from './admin-api.guard';
import { OAuthGuard } from '../../../guards/oauth.guard';
import { ApiDocsComponent } from './features/api-docs/api-docs.component';
import { ApiDocsGuard } from './api-docs.guard';

const routes: Routes = [
  {
    path: "admin/api-keys",
    title: "Admin – Idea Financial Partner",
    component: AppPageComponent,
    canActivate: [OAuthGuard, AdminApiGuard],
    data: {
      appBar: appBarData(),
      appBarDropdown: appBarDropdownData(),
    },
    resolve: {
      appPage: AppPageResolver,
      appSidenav: AppSidenavItemsResolver,
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "right",
            component: AppBarDropdownComponent,
          },
        ],
      },
      {
        path: "",
        outlet: "sidenav-content",
        component: AppSidenavComponent,
      },
      {
        path: "",
        component: BrokerApiKeyListComponent
      },
    ]
  },
  {
    path: "admin/api-docs",
    title: "Admin – Idea Financial Partner",
    component: AppPageComponent,
    canActivate: [ApiDocsGuard],
    data: {
      appBar: appBarData(),
      appBarDropdown: appBarDropdownData(),
    },
    resolve: {
      appPage: AppPageResolver,
      appSidenav: AppSidenavItemsResolver,
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "right",
            component: AppBarDropdownComponent,
          },
        ],
      },
      {
        path: "",
        outlet: "sidenav-content",
        component: AppSidenavComponent,
      },
      {
        path: "",
        component: ApiDocsComponent
      },
    ]
  },
  {
    path: "admin/api-key/new",
    title: "New API key - Idea Broker Portal",
    canActivate: [AdminApiGuard],
    component: AppPageComponent,
    data: {
      appPage: {
          contentClass: "simple",
          contentAlignment: "center-start",
          contentWithoutPadding: true,
          sidenavSubtitle: "",
          sidenavTitle: "",
      },
      appBar: {
        closeAction: AppBarCloseAction.BACK,
        logoHidden: true,
        containerClass: "start-center",
      },
      appBarActions: {
        menuMobile: true,
      },
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "title",
            component: AppBarTitleComponent,
          },
          {
            path: "",
            outlet: "right",
            component: AppBarActionsComponent,
          },
        ],
      },
      {
        path: "",
        component: BrokerApiKeyDetailsComponent
      },
    ],
  },
  {
    path: "admin/api-key/:id",
    title: "Update API key - Idea Broker Portal",
    canActivate: [AdminApiGuard],
    component: AppPageComponent,
    data: {
      appPage: {
          contentClass: "simple",
          contentAlignment: "center-start",
          contentWithoutPadding: true,
          sidenavSubtitle: "",
          sidenavTitle: "",
      },
      appBar: {
        closeAction: AppBarCloseAction.BACK,
        logoHidden: true,
        containerClass: "start-center",
      },
      appBarActions: {
        menuMobile: true,
      },
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "title",
            component: AppBarTitleComponent,
          },
          {
            path: "",
            outlet: "right",
            component: AppBarActionsComponent,
          },
        ],
      },
      {
        path: "",
        component: BrokerApiKeyDetailsComponent
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
